import React from 'react';
import './ClearancePopup.css';

// Default popup content — the single source of truth for the fallbacks
// used when an admin field is left blank. Shared by the live popup and the
// admin preview so both agree.
export const POPUP_DEFAULTS = {
  image: '/uploads/gallery/warehouse-clearance-image.webp',
  eyebrow: 'Warehouse Clearance',
  title: '20% OFF',
  subtext: 'Sign up and get a one-time 20% off code on any in-stock awning or pergola. Limited warehouse inventory, sent straight to your inbox.',
  placeholder: 'you@email.com',
  button: 'Send my 20% off code',
  decline: "No thanks, I'd rather pay full price",
};

// Resolve a settings/form object into the card's display props, applying
// the defaults for any blank field. Used by ClearancePopup (live settings)
// and StorefrontPanel (the edit form) alike.
export function resolvePopupContent(s = {}) {
  return {
    img: s.popup_image || POPUP_DEFAULTS.image,
    eyebrow: s.popup_eyebrow || POPUP_DEFAULTS.eyebrow,
    title: s.popup_title || POPUP_DEFAULTS.title,
    subtext: s.popup_subtext || POPUP_DEFAULTS.subtext,
    placeholder: s.popup_email_placeholder || POPUP_DEFAULTS.placeholder,
    buttonText: s.popup_button || POPUP_DEFAULTS.button,
    declineText: s.popup_decline || POPUP_DEFAULTS.decline,
  };
}

// Presentational clearance-popup card. Rendered inside the overlay by the
// live ClearancePopup, and standalone (readOnly) by the admin preview — so
// the preview is exactly the markup + styles visitors see.
export default function ClearancePopupCard({
  img, eyebrow, title, subtext, placeholder, buttonText, declineText,
  value = '', onChange, onSubmit, submitting = false, error = '',
  onDecline, inputRef, readOnly = false,
}) {
  const handleSubmit = onSubmit || ((e) => e.preventDefault());
  return (
    <div className="clp-card">
      <div className="clp-banner">
        <img src={img} alt={eyebrow} loading="eager" />
      </div>
      <p className="clp-eyebrow">{eyebrow}</p>
      <h2 id="clp-title" className="clp-title">{title}</h2>
      <p className="clp-sub">{subtext}</p>
      <form className="clp-form" onSubmit={handleSubmit} noValidate>
        <input
          ref={inputRef}
          type="email"
          className="clp-input"
          placeholder={placeholder}
          {...(readOnly ? { readOnly: true, defaultValue: '' } : { value, onChange })}
          disabled={submitting}
          autoComplete="email"
          aria-label="Email address"
        />
        <button type="submit" className="clp-submit" disabled={submitting}>
          {submitting ? 'Sending…' : buttonText}
        </button>
        {error ? <p className="clp-error" role="alert">{error}</p> : null}
      </form>
      <button type="button" className="clp-decline" onClick={onDecline}>
        {declineText}
      </button>
    </div>
  );
}
